<template>
  <esg-base-dashboard-card title="핵심 협력사 기준">
    <esg-base-chart height="300px">
      <apex-chart type="heatmap"
                  :options="chartOptions"
                  :width=this.width
                  :height=this.height
                  :series="series"/>
    </esg-base-chart>
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'HeatmapExample',
  components: {EsgBaseDashboardCard, EsgBaseChart},
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
  },
  data: function () {
    return {
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          heatmap: {
            enableShades: false
          }
        },
        dataLabels: {
          enabled: true
        },
        colors: ["#A5A5A5", '#F58C8A', "#A5A5A5", '#F58C8A'],
        xaxis: {
          type: 'category',
          categories: ['Low', 'High'],
          title: {
            text: 'ESG 리스크 노출도',
            offsetY: -27,
            style: {
              fontSize: '8px',
              fontWeight: 'bold',
              color: '#263238'
            },
          },
        },
        yaxis: {
          title: {
            text: '전략적 중요도',
            offsetX: 25,
            style: {
              fontSize: '8px',
              fontWeight: 'bold',
              color: '#263238'
            },
          },
        },
        grid: {
          show: false,
        },
      },
      series: [{
        name: 'Low',
        data: [
          {x: "1", y: 1382},
          {x: "2", y: 457},
        ]
      },
        {
          name: 'High',
          data: [
            {x: "1", y: 544},
            {x: "2", y: 249},
          ]
        }
      ],
    }
  },
  computed: {
    getAmtOfCorp() {
      let amtOfCorp = 0;
      this.series.forEach(obj => {
            obj.data.forEach(val => {
              amtOfCorp += val.y
            })
          }
      );
      return amtOfCorp;
    }

  },
  methods: {
    generateData(count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = (i + 1).toString();
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        series.push({
          x: x,
          y: y
        });
        i++;
      }
      return series;
    }
  }
}
</script>
<style>
.total-num {
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 40px;
  background-color: #FFE500;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-align: center;
}
</style>
